/**
 * @deprecated
 */
export type ContactEmail = {
  uuid: string;
  email: string | null;
  note: string | null;
  default: boolean | null;
};
